// src/app/services/toast-service.service.ts
import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TranslationService } from './translation.service';



@Injectable({ providedIn: 'root' })
export class ToastServiceService {
  constructor(
    private messageService: MessageService,
    private translateService: TranslationService
  ) { }

  private t(key: string): string {
    return this.translateService.translate(key);
  }

  success(summaryKey: string, detailKey?: string) {
    this.messageService.add({
      severity: 'success',
      summary: this.t(summaryKey),
      detail: detailKey ? this.t(detailKey) : undefined
    });
  }

  error(summaryKey: string, detailKey?: string) {
    this.messageService.add({
      severity: 'error',
      summary: this.t(summaryKey),
      detail: detailKey ? this.t(detailKey) : undefined
    });
  }

  warn(summaryKey: string, detailKey?: string) {
    this.messageService.add({
      severity: 'warn',
      summary: this.t(summaryKey),
      detail: detailKey ? this.t(detailKey) : undefined
    });
  }

  info(summaryKey: string, detailKey?: string) {
    this.messageService.add({
      severity: 'info',
      summary: this.t(summaryKey),
      detail: detailKey ? this.t(detailKey) : undefined
    });
  }

  clear() {
    this.messageService.clear();
  }

  /** 🔥 Maneja errores de Firebase con claves traducibles */
  handleFirebaseError(
    error: unknown,
    summaryKey = 'common.error',
    fallback = 'auth.unknown_error'
  ) {
    const detailKey =
      error instanceof Error && typeof error.message === 'string'
        ? error.message
        : fallback;

    this.error(summaryKey, detailKey);
  }

  /** 🔶 Muestra toast cuando un formulario no es válido */
  handleFormInvalid() {
    this.warn('form.invalid');
  }


  /** Mostrar notificación de mensaje */
  showMessageNotification(userName: string, userPhotoUrl: string, messageText: string, url: string, life = 10000 ): void {
    console.log('showMessageNotification', userName, userPhotoUrl, messageText, url);
    this.messageService.add({
      key: 'message',
      severity: 'info',
      summary: messageText,
      life,
      data: { url, name: userName, photoUrl: userPhotoUrl }
    });
  }

  showGiftNotification( userName: string,  giftImageUrl: string, giftName: string, url: string,  life = 10000  ): void {
    console.log('showGiftNotification', userName, giftImageUrl, giftName, url);
    this.messageService.add({
      key: 'gift',
      severity: 'success',
      summary: giftName,
      life,
      data: { url, name: userName,  giftImageUrl }
    });
  }
}
